import { ProductV2, isStoreOfferProduct } from '@common'
import cx from 'classnames'

import { useGameSlug } from '@/features/storefronts/game-provider'

import { CardOffer } from '../card/CardOffer'
import OffersHeader from './OffersHeader'

import styles from './Offers.module.scss'

interface OffersProps {
  products: ProductV2[]
}

const Offers = ({ products }: OffersProps) => {
  const gameSlug = useGameSlug()
  const offers = products.filter(isStoreOfferProduct)

  return (
    <div className={cx(styles.offers, styles[gameSlug])}>
      {gameSlug !== 'brawlstars' && <OffersHeader />}
      {offers.length > 0 && (
        <div className={styles.offersContainer}>
          {offers.map((offer, index) => (
            <CardOffer key={index} game={gameSlug} product={offer} />
          ))}
        </div>
      )}
    </div>
  )
}

export default Offers
